var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-input"},[_c('input',{ref:"inputField",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._v(" "),_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94524308","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SearchInput.vue
// module id = null
// module chunks = 